import { type ImgHTMLAttributes, useEffect, useRef } from "react";

import { applyPixelArtRendering } from "../lib/pixel-art";

/** Keep small artwork sharp without pixelating ordinary large images. */
export function PixelArtImage({ onLoad, ...props }: ImgHTMLAttributes<HTMLImageElement>) {
  const image = useRef<HTMLImageElement>(null);

  useEffect(() => {
    // Cached images may already be complete when their component mounts.
    if (image.current?.complete) applyPixelArtRendering(image.current);
  }, [props.src, props.srcSet, props.className]);

  return <img
    {...props}
    ref={image}
    onLoad={(event) => {
      applyPixelArtRendering(event.currentTarget);
      onLoad?.(event);
    }}
  />;
}
